import { render } from "./ReclamosView.vue?vue&type=template&id=66b77046&lang=true"
import script from "./ReclamosView.vue?vue&type=script&lang=js"
export * from "./ReclamosView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__